import { parseAsBoolean, useQueryState } from 'nuqs';
import { Tool, ToolContent, ToolHeader, ToolInput, ToolOutput } from '../elements/Tool';

const GenericTool = ({ part, isStreaming = false }: { part: any; isStreaming?: boolean }) => {
  const [isDebug] = useQueryState('debug', parseAsBoolean.withDefault(false));
  if (typeof part.type === 'string' && part.type.startsWith('tool-')) {
    const state = 'state' in part ? (part as any).state : undefined;

    if (state === 'output-available' && !isDebug) {
      return null;
    }

    return (
      <div className='mt-2'>
        <Tool defaultOpen={false} isDebug={isDebug}>
          <ToolHeader type={part.type as `tool-${string}`} state={state} isStreaming={isStreaming} isDebug={isDebug} />
          {isDebug && (
            <ToolContent>
              <ToolInput input={'input' in part ? (part as any).input : undefined} />
              <ToolOutput output={'output' in part ? (part as any).output : undefined} errorText={'errorText' in part ? (part as any).errorText : undefined} />
            </ToolContent>
          )}
        </Tool>
      </div>
    );
  }
};

export default GenericTool;
